<script setup lang="ts">
interface IHourFormated {
    from: number;
    to: number;
    icon: string;
    iconBefore?: string;
}

defineProps<IHourFormated>();
</script>
<template>
    <div class="dateFormated">
        <i v-if="iconBefore" :class="`ti ti-${iconBefore}`"></i>
        <div class="date">
            {{ from }}
            <i :class="`ti ti-${icon}`"></i>
            {{ to }}
        </div>
    </div>
</template>
<style scoped lang="scss">
.dateFormated {
    gap: 6px;
    display: flex;
    .date {
        display: flex;
        align-items: center;
        gap: 6px;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        color: $text-main-900;
        > i {
            color: $icon-soft-400;
        }
    }
}
</style>
